import Icon from '@ant-design/icons';
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { ColumnTitles } from '../constants/column-titles.constant';
import { handleNotificationClick } from '../../../../_config/functions/check-notification-and-mark-as-read';

const formatDate = (dateString) => {
	if (!dateString) return '-';
	const date = new Date(dateString);
	if (isNaN(date.getTime())) return '-';
	return date.toLocaleString('es-CL', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	});
};

export const generateColumns = (status, sortOrder, pharmacy) => {
	const sortOrderAntd = sortOrder === 'asc' ? 'ascend' : sortOrder === 'desc' ? 'descend' : null;

	return [

		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].quotation_short_code,
			dataIndex: 'short_code',
			key: 'short_code',
			render: (short_code, record) => (
				<Link to={`/quotation/detail/${record?.quotation_id}`}>
					{short_code}
				</Link>
			),
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].preorder_id,
			dataIndex: 'tracking_id',
			key: 'tracking_id',
		},

		{
			title: ColumnTitles[Enviroment.LANGUAGE].trx_id,
			dataIndex: 'trx_id',
			key: 'trx_id',
			render: (trx_id) => (
				<Link to={`v2/tracking/detail/${pharmacy}/${trx_id}`}>
					{trx_id}
				</Link>
			),		},
		{
			title: ColumnTitles[Enviroment.LANGUAGE].rut,
			dataIndex: 'rut',
			key: 'rut',
			render: (rut) => rut || '-',
		},
		{
			title: ColumnTitles[Enviroment.LANGUAGE].email,
			dataIndex: 'user_email',
			key: 'user_email',
			render: (user_email) => user_email || '-',
		},
		{
			title: ColumnTitles[Enviroment.LANGUAGE].createdAt,
			dataIndex: status === 'PAYMENT_APPROVED' ? 'payment_approved_date' : 'payment_pending_date',
			key: 'date',
			sorter: false,
			sortOrder: sortOrderAntd,
			render: (date) => formatDate(date),
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].detailOrder,
			dataIndex: 'detailOrder',
			key: 'detailOrder',
			render: (_, record) => {
				return (
					<Link
						to={`/preorder/detail/${record?.purchase_id}`}
						onClick={() => {
							handleNotificationClick(record?.purchase_id, pharmacy);
						}}
					>
						<Icon className="link-voucher" component={SearchOutlined} />
					</Link>
				);
			},
		},
	];
};
